import { Modal, ModalBody } from 'reactstrap'

import { SocialModalProps } from '../../../types/props'
import TwitterImg from '../../../assets/images/be-v1/twitter.png'
import FbImg from '../../../assets/images/be-v1/fb.png'
import InstaImg from '../../../assets/images/be-v1/insta.png'
import LinkedInImg from '../../../assets/images/be-v1/linkedIn.png'
import usePosthogEvent from '../../../hooks/use-posthog-event'
import { SocialMediaName } from '../../../hooks/types'
import defaultUrl from '../../../utils/defaultBrandEngagementUrls'

const SocialModal = ({ isModalOpen, toggle, brandEngagement, isLiveStream }: SocialModalProps) => {
  const posthogEvent = usePosthogEvent()

  const linkList = brandEngagement?.page?.followUs || [
    {
      img: TwitterImg,
      title: 'Twitter',
      url:
        (brandEngagement?.content && brandEngagement.content.follow_us?.twitter) ||
        defaultUrl.TWITTER,
    },
    {
      img: FbImg,
      title: 'Facebook',
      url: (brandEngagement?.content && brandEngagement.content.follow_us?.fb) || defaultUrl.FB,
    },
    {
      img: LinkedInImg,
      title: 'LinkedIn',
      url:
        (brandEngagement?.content && brandEngagement.content.follow_us?.linkedin) ||
        defaultUrl.LINKEDIN,
    },
    {
      img: InstaImg,
      title: 'Instagram',
      url:
        (brandEngagement?.content && brandEngagement.content.follow_us?.insta) ||
        defaultUrl.INSTAGRAM,
    },
  ]

  const redirectToUrl = (url: string, name: SocialMediaName) => {
    posthogEvent.sendSocialClickedEvent({ name })
    window.location.href = url
  }
  return (
    <Modal isOpen={isModalOpen} toggle={toggle} centered>
      <ModalBody>
        <div className='d-flex justify-content-center'>
          <div className='modal__links'>
            {linkList.map((link, idx) => (
              <div
                key={idx}
                className='text-center'
                onClick={() => redirectToUrl(link.url, link.title as SocialMediaName)}
              >
                <img className='engagement__icon' src={link.img} alt={link.title} />
                <p className='mt-2'>{link.title}</p>
              </div>
            ))}
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default SocialModal
